var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pulse Display") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "047 Pulse Display"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,0H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3h9v6H8v2H24V30H20V24h9a3,3,0,0,0,3-3V3A3,3,0,0,0,29,0ZM18,30H14V24h4Zm12-9a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H29a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 10,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.865 14.235 16.053 5.658 13.876 10.012 12.155 7.43 9.586 10 8 10 8 12 10.414 12 11.845 10.57 14.124 13.988 15.947 10.342 20.135 19.765 22.717 12 24 12 24 10 21.273 10 19.865 14.235"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplay);
export default __webpack_public_path__ + "static/media/display.0d0427a315aae51b3708a280cb439f52.svg";
export { ForwardRef as ReactComponent };